/* Built-in imports */
import React from "react";

const Hero = React.lazy(() => import("./views/pages/hero/hero.page"));
const About = React.lazy(() => import("./views/pages/about/about.page"));
const Experience = React.lazy(() =>
  import("./views/pages/experience/experience.page")
);
const Contact = React.lazy(() => import("./views/pages/contact/contact.page"));

function App() {
  return (
    <>
      <Hero />
      <About />
      <Experience />
      <Contact />
    </>
  );
}

export default App;
